// 引入全局组件
import Vue from "vue";

import selectUnit from "./selectUnit.vue";
import selectUnitSpan from "./selectUnitSpan.vue";
import pager from "./pager.vue";
import inputAmount from "./inputAmount.vue";
Vue.component("selectUnit", selectUnit);
Vue.component("selectUnitSpan", selectUnitSpan);
Vue.component("Pager", pager);
Vue.component("iAmount", inputAmount);



// WEBPACK FOOTER //
// ./src/components/importComponents.js